import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" })
});
export default SvgCheck;
